export default __webpack_public_path__ + "static/media/map-location.b1431464.svg";